import { useMutation, useQueryClient } from 'react-query';
import Notiflix from 'notiflix';
import axios from 'axios';
import { loadingSvgColor } from 'helpers/utils';

const dataExport = async data => {
  const res = await axios.post(`/app/export`, data);
  return res.data;
};

export const useExtractDataMutation = id => {
  const queryClient = useQueryClient();
  const { mutate } = useMutation({
    mutationFn: dataExport,
    onMutate: () => Notiflix.Loading.hourglass({ svgColor: loadingSvgColor }),
    onError: error => {
      Notiflix.Notify.failure(error?.response?.data?.error ?? error.message);
    },
    onSuccess: async () => {
      await queryClient.invalidateQueries(['GET_PROJECT_FILES', id]);
    },
    onSettled: () => {
      Notiflix.Loading.remove();
    }
  });

  return { mutate };
};
